var RequestTypes = {
  ESTIMATE: 0,
};

module.exports = RequestTypes;
